
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/routes/index';
import { AppProviders } from '@/components/providers/AppProviders';
import { SupabaseAuthProvider } from '@/contexts/SupabaseAuthContext';
import { MarketDataProvider } from '@/contexts/MarketDataContext';
import { serviceWorkerManager } from '@/services/offline/ServiceWorkerManager';
import './index.css';

// Register Service Worker for offline functionality
if ('serviceWorker' in navigator) {
  serviceWorkerManager.register().catch(console.error);
}

function AppWithRouter() {
  return (
    <SupabaseAuthProvider>
      <MarketDataProvider>
        <AppProviders>
          <RouterProvider router={router} />
        </AppProviders>
      </MarketDataProvider>
    </SupabaseAuthProvider>
  );
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <AppWithRouter />
  </StrictMode>,
);
